/* Click-to-play facade: the YouTube iframe is only injected once a viewer asks
   for it, so the section costs one image instead of the full player on load. */
(function () {
  function play(button) {
    var card = button.closest('.lp-video');
    var id = button.dataset.lpVideoId;
    if (!card || !id) return;

    var iframe = document.createElement('iframe');
    iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
    iframe.title = button.dataset.lpVideoTitle || 'Video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.setAttribute('loading', 'lazy');

    card.replaceChildren(iframe);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lp-video-id]');
    if (button) play(button);
  });
})();
